

export const options = {
    method: 'GET',
    headers: {
        'X-RapidAPI-Key': '2b542e28a9msh5618b4f88f477a3p1458eajsn4f2adc785e49',
        'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
    }
};
export const youtubeOptions = {

    method: 'GET',
    headers: {
        'X-RapidAPI-Key': '897b170117msha53096b9ea60a6ap1b1eb7jsncdc763dfbd63',
        'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
    }
};